// This file will be deleted once all the calculators are configBuilder free
// to be deleted

import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { ApplyNowLink } from '@nerdwallet/react-apply-now';

import { HOME_LIGHT_IMPRESSION } from '../../../lib/analytics-constants';
import registerLink from '../../../lib/register-link';

const config = {
  cards: [
    {
      header: 'Rates',
      text: 'A low rate can save you hundreds each year.',
      img: iconUri('House_pricetag'),
      alt: 'House with price tag',
      link: {
        url: '/mortgages/mortgage-rates?trk_source=mortgages_mc_toolcard&trk_content=rates_toolcard_card+pos1&trk_destination=mortgage-rates&trk_origin=calculate-mortgage-payment&trk_app=tool&purchasePrice={{0}}&downPayment={{1}}&zipCode={{2}}&bypass=true',
        text: 'Compare mortgage rates',
      },
      keys: [
        {
          key: 'inputs.purchasePrice',
        },
        {
          key: 'inputs.downPayment',
        },
        {
          key: 'outputs.zip',
        },
      ],
    },
    {
      header: 'Credit',
      text: 'See how a mortgage impacts your score.',
      img: iconUri('Credit_score'),
      alt: 'Credit score gauge',
      link: registerLink(
        'mc',
        {
          element: 'ad_unit',
          location: 'toolcard_card+pos2',
        },
        'Get your free credit score'
      ),
    },
    {
      header: 'Lenders',
      text: 'Get your true budget and find a home with ease.',
      img: iconUri('Approval'),
      alt: 'Thumbs up with dollar sign',
      link: {
        url: '/mortgages/mortgage-pre-approval?trk_source=mortgages_mc_toolcard&trk_content=preapproval_toolcard_card+pos3&trk_destination=mortgage-pre-approval&trk_origin=calculate-mortgage-payment&trk_app=tool&purchasePrice={{0}}&downPayment={{1}}&zipCode={{2}}',
        text: 'Get preapproved',
      },
      keys: [
        {
          key: 'inputs.purchasePrice',
        },
        {
          key: 'inputs.downPayment',
        },
        {
          key: 'outputs.zip',
        },
      ],
    },
    {
      header: 'Agents',
      text: 'Get matched with a top agent in your area.',
      img: iconUri('Real_estate_1'),
      alt: 'Real estate sign',
      link: {
        linkComponent: ApplyNowLink,
        text: 'Find a real estate agent',
        props: {
          linkType: 'apply_now_button',
          logImpression: false,
          link: '/redirect/eeadcaf6-38db-11eb-a727-ef6ff84e35fe',
        },
        getAdditionalProps: (impressionData) => ({
          impressionId: impressionData?.impressionId,
        }),
      },
      impressionEventPayload: ({ sectionPosition, sectionName }) => ({
        ...HOME_LIGHT_IMPRESSION,
        payload: {
          ...HOME_LIGHT_IMPRESSION.payload,
          section_name: sectionName,
          section_position: sectionPosition,
        },
      }),
    },
  ],
};
export default config;
